import React, { useEffect } from 'react';
import { useWebView } from '@mp';
import { PhoneScreeningSchedulerForm } from '@mp/components/calendlyModal/PhoneSchedulerForm.web';

const ReScreeningSchedulerEmbedded = () => {
  const { setIsWebView } = useWebView();

  useEffect(() => {
    setIsWebView(true);
  }, []);

  return <PhoneScreeningSchedulerForm height="100vh" />;
};

export default ReScreeningSchedulerEmbedded;
